import React from 'react';
import { Outlet, Link, useLocation } from 'react-router-dom';
import { HireIqLogo } from '@/components/HireIqLogo';

export default function PublicLayout() {
  const { pathname } = useLocation();
  const hideHeader = pathname === '/login';

  return (
    <div className="min-h-screen bg-[hsl(var(--background))]">
      <div className="hero-glow">
        {!hideHeader && (
          <header className="mx-auto flex max-w-[1400px] items-center justify-between px-6 py-5">
            <Link to="/login" className="flex items-center" data-testid="public-brand-logo-link">
              <HireIqLogo size="sm" className="max-w-[180px]" data-testid="public-brand-logo" />
            </Link>
            <Link to="/login" className="text-sm font-medium text-muted-foreground transition-colors hover:text-foreground">HR sign in →</Link>
          </header>
        )}
      </div>
      <Outlet />
    </div>
  );
}
